<template>
   <div class="info">
        <div class="info-title">
        <span class="title">{{ title }}</span>
         <span class="tag" v-if="tag">{{ tag }}</span>
        </div>
        <div class="time">截止日期：{{ endTimeText }}</div>
        <div class="description" v-if="description">{{description}}</div>
    </div>
</template>

<script>
import { TimeFormat } from "@/assets/js/utils";
export default {
    name:'DetailInfo',
    props: {
        title: {
            type: String,
            default:''
        },
        endTime: {
            type:Number,
            default:undefined
        },
        description: {
            type:String,
            default: ''
        },
        tag: {
            type: String,
            default:''
        }
    },
    computed: {
        endTimeText() {
            return this.endTime? TimeFormat.timestampSecondToChinese(this.endTime)
        : "";
        }
    }
}
</script>

<style lang="less" scoped>
.info {
  background-color: #fff;
  padding: 16px;
}
.title {
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  vertical-align: middle;
}
.tag {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 4px;
  background: @theme-orange;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #fff;
  margin-left: 8px;
}
.time {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 8px;
}
.description {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
  margin-top: 10px;
}
</style>